module.exports = __webpack_public_path__ + "img/kefu.974329ff.png";